import React, { useMemo, useEffect } from 'react';
//ANTD
import { Empty, Button, Checkbox } from 'antd';
//COMPONENTS
import TourItem from '../components/tourItem';
import EmptyTabList from './emptyTabList';

import { FormattedMessage, useIntl } from 'react-intl';
//IMAGE
import create_tour from 'static/img/ts_menu_rideplan.png';
import TransferButton from './transferButton';
import { TRASFER_GPS_TABS } from '../../../../constants/transfer.constants';
import { MultiDayTourItem } from '../components/multiDayTourItem';
import { Type } from 'app/constants/TourPoints';
const HistoryTab = (props) => {
  const {
    setHistoryCheckeList,
    historyTourList,
    historyCheckedList,
    getHistoryTour,
    TourBasketDataDelete,
  } = props;

  useEffect(() => {
    getHistoryTour();
  }, []);

  const getScope = item => (item.scope) ? item.scope : ((item.type && item.type !== Type.START && item.type !== Type.END && item.type !== Type.VIA && item.type !== Type.DRAG) ? item.type : ((typeof item.stickToRoad === 'function') ? 'tourpoint' : 'tour'));
  
  return (
    <React.Fragment>
      <div
        className="listDownlaodTour"
        style={props.getListStyleIE(historyCheckedList.length)}
      >
        {historyTourList.length === 0 ? (
          <EmptyTabList hasButton={false} />
        ) : (
            <Checkbox.Group
              value={historyCheckedList}
              onChange={setHistoryCheckeList}
            >
              {/* {tourList} */}
              {historyTourList.map((item) => {
                const isLinkEnabled = getScope(item) !== 'tourpoint';
                if (item.multiDay === true) {
                  return <MultiDayTourItem item={item} checkedList={historyCheckedList} setCheckedList={setHistoryCheckeList} key={item.id} />
                } else {
                  return (
                    <Checkbox value={item.id} key={item.id}>
                      <TourItem item={item} TourBasketDataDelete={TourBasketDataDelete} isLinkEnabled={isLinkEnabled} key={item.id + item.type} />
                    </Checkbox>
                  )
                }
              })}
            </Checkbox.Group>
          )}
      </div>
      <TransferButton
        hanleClick={() =>
          props.transferRoutes(
            historyTourList,
            historyCheckedList,
            TRASFER_GPS_TABS.HISTORY
          )
        }
        isDisabled={historyCheckedList.length === 0}
        isDetectedTT={props.isDetectedTT}
      />
    </React.Fragment>
  );
};

export default HistoryTab;
